// =============================================
// File: src/services/dashboardService.js
// =============================================

import axiosInstance from './axiosConfig';

const dashboardService = {
  // Get dashboard overview stats
  getDashboardStats: async () => {
    try {
      const response = await axiosInstance.get('/dashboard/stats');
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get revenue analytics
  getRevenueAnalytics: async (period = 'month') => {
    try {
      const response = await axiosInstance.get('/dashboard/revenue', { 
        params: { period } 
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get sales chart data
  getSalesChartData: async (startDate, endDate) => {
    try {
      const response = await axiosInstance.get('/dashboard/sales-chart', {
        params: { startDate, endDate }
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get top selling products
  getTopSellingProducts: async (limit = 10) => {
    try {
      const response = await axiosInstance.get('/dashboard/top-products', {
        params: { limit }
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get recent orders
  getRecentOrders: async (limit = 10) => {
    try {
      const response = await axiosInstance.get('/dashboard/recent-orders', {
        params: { limit }
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get customer statistics
  getCustomerStats: async () => {
    try {
      const response = await axiosInstance.get('/dashboard/customer-stats');
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get inventory alerts
  getInventoryAlerts: async () => {
    try {
      const response = await axiosInstance.get('/dashboard/inventory-alerts');
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get conversion metrics
  getConversionMetrics: async (period = 'month') => {
    try {
      const response = await axiosInstance.get('/dashboard/conversions', {
        params: { period }
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Export dashboard report
  exportDashboardReport: async (format = 'pdf', dateRange) => {
    try {
      const response = await axiosInstance.post('/dashboard/export', 
        { format, ...dateRange },
        { responseType: 'blob' }
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
};

export default dashboardService;